import { createSlice } from '@reduxjs/toolkit';
import { type EUserRoles } from '../enums/EUserRoles';

export const userSlice = createSlice({
  name: 'authentication',
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  initialState: {
    id: '',
    email: '',
    firstName: '',
    lastName: '',
    isAdmin: false,
    isCurrentUser: false,
    isStaff: false,
    isPortfolioManager: false,
    roles: []
  } as {
    id: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    isAdmin: boolean | undefined;
    isCurrentUser: boolean | undefined;
    isStaff: boolean | undefined;
    isPortfolioManager: boolean | undefined;
    roles: EUserRoles[];
  },
  reducers: {
    init: (state, action) => {
      state.firstName = action.payload.account.first_name;
      state.lastName = action.payload.account.last_name;
    },
    updateUserObject: (state, action) => {
      state.email = action.payload.email;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.id = action.payload.id;
      state.isAdmin = action.payload.isAdmin;
      state.isCurrentUser = action.payload.isCurrentUser;
      state.isStaff = action.payload.isStaff;
      state.isPortfolioManager = action.payload.isPortfolioManager;
      state.roles = action.payload.roles ?? state.roles;
    }
  }
});

export const { init, updateUserObject } = userSlice.actions;
export default userSlice.reducer;
